import React, { memo, useState } from "react";
import {
  SelectInput,
  Filter,
  List as BaseList,
  Datagrid,
  TextField,
  DateInput,
  DateField,
  ArrayField,
  SingleFieldList,
  ChipField,
  BooleanField,
  useNotify,
  useDataProvider,
  SimpleForm,
  FunctionField,
  useRefresh,
} from "react-admin";
import { SelectProviderInput } from "./SelectProviderIntput";

const BookingFilter = ({ ...props }) => {
  return (
    <Filter {...props}>
      <SelectProviderInput source="providerId" label="Proveedor" alwaysOn />
      <SelectInput
        label="Estado"
        source="status"
        choices={[
          { id: "Pendiente", name: "Pendiente" },
          { id: "Confirmado", name: "Confirmado" },
          { id: "En proceso", name: "En proceso" },
          { id: "Finalizado", name: "Finalizado" },
          {
            id: "Cancelada por el proveedor",
            name: "Cancelada por el proveedor",
          },
          { id: "Cancelada por el cliente", name: "Cancelada por el cliente" },
        ]}
      />
      <DateInput label="Desde" source="bookingDate>" />
      <DateInput label="Hasta" source="bookingDate<" />
    </Filter>
  );
};

export const List = (props) => {
  return (
    <BaseList sort={{ field: "bookingDate", order: "DESC" }} filters={<BookingFilter />} {...props}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="_id" label="ID" />
        <TextField source="provider.name" label="Proveedor" />

        <ArrayField source="serviceCart" label="Servicios Solicitados">
          <SingleFieldList>
            <ChipField source="service.name" />
          </SingleFieldList>
        </ArrayField>
        <DateField source="bookingDate" label="Fecha de Inicio" showTime locales="es-ES" />
        <FunctionField
          source="paymentInfo.totalPrice"
          label="Precio Total (Bs.)"
          render={(record) =>
            record.paymentInfo?.totalPrice ? parseFloat(record.paymentInfo.totalPrice).toFixed(2) : "0.00"
          }
        />
        {/* <TextField source="paymentInfo.paymentMethod" label="Método de Pago" /> */}
        <TextField source="createdFrom" label="Método" />
        <FunctionField
          source="paymentInfo.paymentMethod"
          label="Método de Pago"
          render={(record) => (
            <div onClick={(e) => e.stopPropagation()}>
              {" "}
              <PaymentStatusField record={record} />
            </div>
          )}
        />
        {/* <TextField source="status" label="Estado de Reserva" /> */}
        <FunctionField
          source="status"
          label="Estado de Reserva"
          render={(record) => (
            <div onClick={(e) => e.stopPropagation()}>
              {" "}
              <BookingStatus record={record} />
            </div>
          )}
        />
        <TextField source="paymentInfo.status" label="Estado de Pago" />
        <TextField source="feedbackInfo.rating" label="Rating" />
        <BooleanField source="isInBranch" label="¿Servicio en Sucursal?" />
        <TextField source="branch.name" label="Sucursal" />
      </Datagrid>
    </BaseList>
  );
};

const status = (record) => {
  if (record.status === "Pendiente de cotizacion") {
    return [
      { id: "Pendiente de cotizacion", name: "Pendiente de cotización" },
      { id: "Confirmado", name: "Enviar cotización y confirmar" },
      // { id: "Pendiente", name: "Pendiente" },
      // { id: "Confirmado", name: "Confirmado" },
      // { id: "En proceso", name: "En proceso" },
      // { id: "Finalizado", name: "Finalizado" },
      { id: "Cancelada por el proveedor", name: "Cancelado" },
    ];
  }
  if (record.status === "Cotizacion enviada") {
    return [{ id: "Cotizacion enviada", name: "Cotización enviada" }];
  }
  if (record.status === "Pendiente") {
    return [
      { id: "Pendiente", name: "Pendiente" },
      { id: "Confirmado", name: "Confirmar" },
      { id: "Cancelada por el proveedor", name: "Cancelar" },
    ];
  }
  if (record.status === "Confirmado") {
    return [
      { id: "Confirmado", name: "Confirmado" },
      { id: "En proceso", name: "En proceso" },
      { id: "Finalizado", name: "Finalizar" },
      { id: "Cancelada por el proveedor", name: "Cancelar" },
    ];
  }
  if (record.status === "En proceso") {
    return [
      { id: "En proceso", name: "En proceso" },
      { id: "Finalizado", name: "Finalizar" },
      { id: "Cancelada por el proveedor", name: "Cancelar" },
    ];
  }
  if (record.status === "Finalizado") {
    return [{ id: "Finalizado", name: "Finalizado" }];
  }
  if (record.status === "Cancelada por el proveedor") {
    return [{ id: "Cancelada por el proveedor", name: "Cancelado por el proveedor" }];
  }
  if (record.status === "Cancelada por el cliente") {
    return [{ id: "Cancelada por el cliente", name: "Cancelado por el cliente" }];
  }
};

const BookingStatus = memo(({ record }) => {
  console.log("record", record);
  const [loading, setLoading] = useState(false);
  const [choices, setChoices] = useState(status(record));
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const handleChange = async (newStatus) => {
    setLoading(true);
    try {
      await dataProvider.update("booking", {
        id: record._id,
        data: { status: newStatus, previousStatus: record.status },
        meta: { customAction: "updateStatus" },
      });

      setChoices(status({ ...record, status: newStatus }));

      notify("Actualizado correctamente", { type: "success" });
    } catch (error) {
      console.error("Error al actualizar estado de pago:", error);
      notify("Error al actualizar", { type: "error" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <SimpleForm toolbar={false}>
      <SelectInput
        source="status"
        label="Estado de Reserva"
        choices={choices || []}
        disabled={loading}
        onChange={(e) => {
          console.log("e.target.value", e.target);
          return handleChange(e.target.value);
        }}
        style={{ margin: 0, padding: 0 }}
      />
    </SimpleForm>
  );
});
const paymentMethods = [
  { id: "Efectivo", name: "Efectivo" },
  { id: "Tarjeta", name: "Tarjeta" },
  { id: "QR", name: "QR" },
  { id: "Tigo Money", name: "Tigo Money" },
  { id: "Cortesia", name: "Cortesia" },
];

const PaymentStatusField = memo(({ record }) => {
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const handleChange = async (newStatus) => {
    setLoading(true);
    const totalPrice =
      newStatus === "Cortesia" ? Number(0) : record.serviceCart?.reduce((a, b) => a + (b.price || 0), 0) || 0;

    try {
      await dataProvider.update("booking", {
        id: record._id,
        data: { totalPrice: totalPrice },
        meta: { customAction: "updateTotalPrice" },
      });

      await dataProvider.update("booking", {
        id: record._id,
        data: { paymentMethod: newStatus },
        meta: { customAction: "updatePaymentMethod" },
      });
      refresh();
      notify("Actualizado correctamente", { type: "success" });
    } catch (error) {
      console.error("Error al actualizar estado de pago:", error);
      notify("Error al actualizar", { type: "error" });
    } finally {
      setLoading(false);
    }
  };
  return (
    <SimpleForm toolbar={false}>
      <SelectInput
        source="paymentInfo.paymentMethod"
        label="Método de Pago"
        choices={paymentMethods}
        disabled={loading}
        onChange={(e) => {
          return handleChange(e.target.value);
        }}
        style={{ margin: 0, padding: 0 }}
      />
    </SimpleForm>
  );
});
